var scope_0 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ac3da95b29460c1f100a9b6b5478646.js').default;
var scope_1 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/182a57b7a328e527ccdaad39d2bae881.js').default;
var scope_2 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/45d3b483907ac71594f2d65490e1f092.js').default;
var scope_3 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8ea5702aae8405dcdc3f45e08be429a5.js').default;
var scope_4 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96a79120d4c21e146863fc5d8f598275.js').default;
var scope_5 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a2976de553ab5f3ac2352f82d58af48.js').default;
var scope_6 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a5ef56b0ab1acb153d58e79b76f626e2.js').default;
var scope_7 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad0665f34d65e2c2a141d907e3c28bdc.js').default;
var scope_8 = require('/Users/jricher/Projects/oauth.xyz-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d6ec188d4da0159116c642adbfc9adf6.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    